import { Meteor } from 'meteor/meteor';

export const getLanguage = () => {
  return Meteor.isClient && Meteor.user()?.language || 'en-us';
};

export const strings = {
  Username(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Username';
    }
  },
  Password(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Password';
    }
  },
  NewPassword(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'New Password';
    }
  },
  SignIn(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Sign In';
    }
  },
  SignUp(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Sign up';
    }
  },
  Welcome(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Welcome';
    }
  },
  PleaseEnterYourLoginDetailsBelow(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Please enter your login details below.';
    }
  },
  Submit(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Submit';
    }
  },
  CreateFreeAccount(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Create a free account';
    }
  },
  DontHaveAnAccount(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Don\'t have an account?';
    }
  },
  MakeOneHere(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Make one here';
    }
  },
  InvalidUsernameOrPassword(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Invalid Username or Password';
    }
  },
  Logout(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Logout';
    }
  },
  ForgotPassword(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Forgot password?';
    }
  },
  SendResetLink(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Send Reset Link';
    }
  },
  ForgotPasswordInstructions(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Please enter your email below';
    }
  },
  ForgotPasswordEmailInstructions(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'If you requested to reset your password, please click the link below.';
    }
  },
  ResetPassword(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Reset Password';
    }
  },
  SetPassword(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Set Password';
    }
  },
  PleaseCheckYourEmailAndOrSmsForPasswordResetLink(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Please check your email and/or mobile device for a password reset link.';
    }
  },
  PasswordSuccessfullyChanged(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Password successfully changed';
    }
  },
  YourUsernameIs(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Your username is';
    }
  },
  Profile(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Profile';
    }
  },
  ProfilePicture(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Profile Picture';
    }
  },
  Save(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Save';
    }
  },
  Pinned(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Pinned';
    }
  },
  Loading(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Loading';
    }
  },
  Update(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Update';
    }
  },
  Updated(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Updated';
    }
  },
  Saved(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Saved';
    }
  },
  Organizations(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Organizations';
    }
  },
  Organization(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Organization';
    }
  },
  Name(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Name';
    }
  },
  Address(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Address';
    }
  },
  City(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'City';
    }
  },
  State(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'State';
    }
  },
  ZipCode(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Zip Code';
    }
  },
  Zipcode(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Zip Code';
    }
  },
  New(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'New';
    }
  },
  Edit(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Edit';
    }
  },
  Search(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Search';
    }
  },
  Users(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Users';
    }
  },
  User(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'User';
    }
  },
  Email(language?: string) {
    language = language || getLanguage();
    switch (language) {
      case 'fr-ca':
        return 'courriel';
      default: return 'Email';
    }
  },
  InvalidPasswordError(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Error: password must contain at least 1 number, 1 letter and a special character (!&_?*)';
    }
  },
  UsernameAlreadyTaken(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Error: email already exists';
    }
  },
  InvalidEmailAddress(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Error: invalid email address';
    }
  },
  ThankYouForSigningUpMessage(email: string, language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return `Thank you for signing up. Please check your inbox at ${email} to verify your email address.`;
    }
  },
  GoToLogin(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Go to Login';
    }
  },
  NoResults(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'No Results';
    }
  },
  Roles(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Roles';
    }
  },
  SelectAll(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Select All';
    }
  },
  ChooseOrganizationFirst(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Choose Organization First';
    }
  },
  Expand(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Expand';
    }
  },
  Collapse(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Collapse';
    }
  },
  ThereAreNoRecordsForThisPage(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'There are no records for this page';
    }
  },
  CreateOne(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Create One';
    }
  },
  English(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'English';
    }
  },
  French(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'French';
    }
  },
  ThisIsAnAutomatedEmailPleaseDoNotReply(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'This is an automated email, please do not reply.';
    }
  },
  Hi(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Hi';
    }
  },
  Timezone(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Timezone';
    }
  },
  Sunday(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Sunday';
    }
  },
  Monday(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Monday';
    }
  },
  Tuesday(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Tuesday';
    }
  },
  Wednesday(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Wednesday';
    }
  },
  Thursday(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Thursday';
    }
  },
  Friday(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Friday';
    }
  },
  Saturday(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Saturday';
    }
  },
  January(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'January';
    }
  },
  February(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'February';
    }
  },
  March(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'March';
    }
  },
  April(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'April';
    }
  },
  May(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'May';
    }
  },
  June(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'June';
    }
  },
  July(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'July';
    }
  },
  August(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'August';
    }
  },
  September(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'September';
    }
  },
  October(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'October';
    }
  },
  November(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'November';
    }
  },
  December(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'December';
    }
  },
  Status(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Status';
    }
  },
  Delete(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Delete';
    }
  },
  Deleted(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Deleted';
    }
  },
  NotFound(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Not Found';
    }
  },
  DeleteSelected(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Delete Selected';
    }
  },
  ActivateSelected(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Activate Selected';
    }
  },
  Filters(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Filters';
    }
  },
  Time(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Time';
    }
  },
  Cancel(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Cancel';
    }
  },
  Yes(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Yes';
    }
  },
  No(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'No';
    }
  },
  Active(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Active';
    }
  },
  Draft(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Draft';
    }
  },
  Completed(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Completed';
    }
  },
  Archived(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Archived';
    }
  },
  Details(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Details';
    }
  },
  Sent(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Sent';
    }
  },
  Deactivate(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Deactivate';
    }
  },
  Inactive(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Inactive';
    }
  },
  All(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'All';
    }
  },
  AnErrorOccurredPleaseTryAgainOrContactSupport(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'An error occurred. Please try again or contact support.';
    }
  },
  BackToLogin(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Back to Login';
    }
  },
  Settings(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Settings';
    }
  },
  Done(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Done';
    }
  },
  PasswordRules(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Password must be at least 8 characters';
    }
  },
  SetUsernameOrPassword(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Set Username/Password';
    }
  },
  Admin(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Admin';
    }
  },
  Dispatcher(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Dispatcher';
    }
  },
  Accounts(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Accounts';
    }
  },
  Account(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Account';
    }
  },
  SuperUser(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Super User';
    }
  },
  YouAreNotPermitted(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'You do not have access to this page.';
    }
  },
  Theme(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Theme';
    }
  },
  Light(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Light';
    }
  },
  PleaseSelectAnOrganization(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Please select an Organization';
    }
  },
  AccountIsDeactivated(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Account is deactivated';
    }
  },
  GoToHomePage(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Go to homepage.';
    }
  },
  GeneratingPrintView(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Generating Print/PDF...';
    }
  },
  Logs(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Logs';
    }
  },
  Trace(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Trace';
    }
  },
  Info(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Info';
    }
  },
  Warning(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Warning';
    }
  },
  Error(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Error';
    }
  },
  Critical(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Critical';
    }
  },
  Logo(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Logo';
    }
  },
  NewAccount(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'New Account';
    }
  },
  From(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'From';
    }
  },
  To(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'To';
    }
  },
  Result(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Result';
    }
  },
  Results(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Results';
    }
  },
  Description(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Description';
    }
  },
  Verify(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Verify';
    }
  },
  iAgreeToTheTermsOfService(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'I agree to the Terms of Service';
    }
  },
  TermsOfService(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'terms of service';
    }
  },
  AlreadyHaveAnAccount(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Already have an account?';
    }
  },
  WeJustNeededToMakeSureYourEmailAddressIsReal(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'We just needed to make sure that your email address is real. Please click the button below to verify.';
    }
  },
  EmailVerification(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Email Verification';
    }
  },
  ThankYouYourEmailHasBeenVerified(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Thank you! Your email has been verified.';
    }
  },
  InvalidOrExpiredVerificationToken(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Invalid or expired verification token.';
    }
  },
  PleaseVerifyYourEmailAddressBeforeLoggingIn(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Please verify your email address before login in.';
    }
  },
  PleaseVerifyYourEmailAddressToAccessThisPage(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Please verify your email address to access this page.';
    }
  },
  MyOrganization(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'My Organization';
    }
  },
  VerificationRequiredMessage(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Please verify your email address to unlock all features. Click here to resend the verification email.';
    }
  },
  SelectFile(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Select File';
    }
  },
  Uploading(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Uploading';
    }
  },
  Manage(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Manage';
    }
  },
  Home(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Home';
    }
  },
  ResendVerificationEmail(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Resend Verification Email';
    }
  },
  SendLoginLink(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Send Login Link';
    }
  },
  Conversations(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Conversations';
    }
  },
  Conversation(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Conversation';
    }
  },
  Messages(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Messages';
    }
  },
  Message(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Message';
    }
  },
  You(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'You';
    }
  },
  NewMessages(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'New messages';
    }
  },
  Optional(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Optional';
    }
  },
  Environment(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Environment';
    }
  },
  SupportTicket(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Support Ticket';
    }
  },
  SupportTickets(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Support Tickets';
    }
  },
  Support(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Support';
    }
  },
  CreatedAt(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Created';
    }
  },
  SupportCase(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Support Case';
    }
  },
  Files(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Files';
    }
  },
  Reply(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Reply';
    }
  },
  YourSupportTicketHasBeenUpdated(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Your support ticket has been updated. Please do not reply to this email, but View Details below to reply in the app.';
    }
  },
  ContactInformation(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Contact Information';
    }
  },
  YouHaveNewMessages(num: number, language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return `You have ${num} new message${num === 1 ? '' : 's'}`;
    }
  },
  GoToMessageCentre(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Go To Message Centre';
    }
  },
  Impersonate(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Impersonate';
    }
  },
  Integrations(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Integrations';
    }
  },
  NameEmailPassword(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Name, Email, Password';
    }
  },
  ThirdPartyConnections(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Third Party Connections';
    }
  },
  DeleteMyAccount(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Delete My Account';
    }
  },
  AreYouSureYouWantToDeleteYourAccount(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Are you sure you want to delete your profile? This action cannot be undone!';
    }
  },
  ClickTheLinkBelowToLoginToYourAccount(username: string, language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return `Click below to login to your account as ${username}`;
    }
  },
  LinkSentPleaseCheckYourInbox(email: string, language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return `Link Sent. Please check your inbox at ${email}`;
    }
  },
  UseGoogle(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Use Google';
    }
  },
  UseDiscord(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Use Discord';
    }
  },
  ThankYouForUsingAuth(serviceName: string, language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return `Thank you for using ${serviceName} auth. You may close this tab.`;
    }
  },
  AlmostDoneClickButtonBelowToCompleteAuth(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Almost Done! Click the button below to complete your authorization';
    }
  },
  CompleteAuthorization(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Complete Authorization';
    }
  },
  DevTools(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Dev Tools';
    }
  },
  Address2(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Address 2';
    }
  },
  Suite(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Suite';
    }
  },
  ViewDetails(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'View Details';
    }
  },
  Project(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Project';
    }
  },
  Projects(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Projects';
    }
  },
  Carrier(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Carrier';
    }
  },
  Carriers(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Carriers';
    }
  },
  McNumber(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'MC Number';
    }
  },
  DotNumber(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'DOT Number';
    }
  },
  ContactName(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Contact Name';
    }
  },
  ContactEmail(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Contact Email';
    }
  },
  ContactPhone(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Contact Phone';
    }
  },
  Line(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Line';
    }
  },
  Line2(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Line 2';
    }
  },
  NewProject(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'New Project';
    }
  },
  ProjectInfo(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Project Info';
    }
  },
  Notes(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Notes';
    }
  },
  LiveNotes(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Live Notes';
    }
  },
  LivePhotos(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Live Photos';
    }
  },
  ProductionMeters(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Production Meters';
    }
  },
  Tags(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Tags';
    }
  },
  Visit(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Visit';
    }
  },
  Copy(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Copy';
    }
  },
  PullSystems(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Pull Systems';
    }
  },
  ThankYouForConnectingYourAccount(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Thank you for connecting your account';
    }
  },
  SystemsFound(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Systems Found';
    }
  },
  Created(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Created';
    }
  },
  AssignedTo(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Assigned To';
    }
  },
  ProjectNameIsRequired(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Project name is required';
    }
  },
  AddOrModifyAccountsInYourOrg(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Add or modify User Accounts in your Organization';
    }
  },
  UtilityAccounts(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Utility Accounts';
    }
  },
  ConsumptionMeters(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Consumption Meters';
    }
  },
  ExportToCsv(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Export to CSV';
    }
  },
  // Carrier equipment types
  EquipmentTypes(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Equipment Types';
    }
  },
  Hotshot(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Hotshot';
    }
  },
  Flatbed48(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return '48\' Flatbed';
    }
  },
  Flatbed53(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return '53\' Flatbed';
    }
  },
  StepDeck48(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return '48\' Step Deck';
    }
  },
  StepDeck53(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return '53\' Step Deck';
    }
  },
  DoubleDrop(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Double Drop';
    }
  },
  Rgn(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'RGN';
    }
  },
  ExtendableRgn(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Extendable RGN';
    }
  },
  FlatbedExtendable(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Flatbed Extendable';
    }
  },
  StepDeckExtendable(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Step Deck Extendable';
    }
  },
  MultiAxleRgn(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Multi-Axle RGN';
    }
  },
  ModularPlatform(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Modular/Platform';
    }
  },
  Dolly(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Dolly';
    }
  },
  // Driver entity
  Driver(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Driver';
    }
  },
  Drivers(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Drivers';
    }
  },
  Flatbed(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Flatbed';
    }
  },
  DryVan(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Dry Van';
    }
  },
  Reefer(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Reefer';
    }
  },
  StepDeck(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Step Deck';
    }
  },
  RgnLowboy(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'RGN/Lowboy';
    }
  },
  BoxTruck(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Box Truck';
    }
  },
  PowerOnly(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Power Only';
    }
  },
  DriverRole(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Driver';
    }
  },
  CarrierDispatcher(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Carrier Dispatcher';
    }
  },
  OwnerOperator(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Owner-Operator';
    }
  },
  MainContact(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Main Contact';
    }
  },
  Equipment(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Equipment';
    }
  },
  Role(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Role';
    }
  },
  // Carrier documents
  Document(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Document';
    }
  },
  Documents(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Documents';
    }
  },
  DocumentType(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Document Type';
    }
  },
  VendorPacket(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Vendor Packet';
    }
  },
  InsuranceCertificate(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Insurance Certificate';
    }
  },
  OperatingAuthority(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Operating Authority';
    }
  },
  W9(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'W9';
    }
  },
  Other(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Other';
    }
  },
  File(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'File';
    }
  },
  PreferredLanes(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Notes / Preferred Lanes';
    }
  },
  CompanyName(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Company Name';
    }
  },
  Phone(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Phone';
    }
  },
  BillingAccessCode(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Billing Access Code';
    }
  },
  Website(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Website';
    }
  },
  UpdatedAt(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Updated At';
    }
  },
  // Customer
  Customer(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Customer';
    }
  },
  Customers(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Customers';
    }
  },
  AccountingEmails(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Accounting / Invoice Emails';
    }
  },
  // Customer Address
  Addresses(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Addresses';
    }
  },
  LocationName(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Location Name / Facility';
    }
  },
  StreetAddress(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Street Address';
    }
  },
  // Load entity
  Load(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Load';
    }
  },
  Loads(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Loads';
    }
  },
  Reference(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Reference';
    }
  },
  PoNumber(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'PO Number';
    }
  },
  LgxNumber(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'LGX #'; }
  },
  OrderNumber(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Order Number'; }
  },
  VendorRate(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Vendor Rate'; }
  },
  CarrierRate(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Carrier Rate';
    }
  },
  CustomerRate(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Customer Rate';
    }
  },
  AssignmentType(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Assignment Type';
    }
  },
  CarrierDriver(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Carrier / Driver';
    }
  },
  CraneVendor(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Crane Vendor';
    }
  },
  TransloadingStorage(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Transloading / Storage';
    }
  },
  // Load equipment types
  StepDeckDropDeck(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Step Deck / Drop Deck';
    }
  },
  LowboyRgn(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Lowboy / RGN';
    }
  },
  Conestoga(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Conestoga';
    }
  },
  // Load statuses
  StatusRfq(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'RFQ';
    }
  },
  StatusOpen(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Open';
    }
  },
  StatusPending(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Pending';
    }
  },
  StatusNotBooked(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Not Booked';
    }
  },
  StatusLive(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Live';
    }
  },
  StatusAtPickup(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'At Pickup';
    }
  },
  StatusEnRoute(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'En Route';
    }
  },
  StatusAtDropoff(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'At Drop-off';
    }
  },
  StatusDeliveredPoPod(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Delivered: PO & POD Needed';
    }
  },
  StatusReadyToInvoice(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Ready to Invoice';
    }
  },
  StatusReadyToReview(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Ready to Review';
    }
  },
  StatusReadyToSend(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Ready to Send';
    }
  },
  StatusInvoiced(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Invoiced';
    }
  },
  StatusLiveArchived(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Archived (no invoice)';
    }
  },
  StatusArchived(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Archived';
    }
  },
  // Stops
  Stops(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Stops';
    }
  },
  Pickup(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Pickup';
    }
  },
  Dropoff(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Drop-off';
    }
  },
  AddPickup(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return '+ Pickup';
    }
  },
  AddDropoff(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return '+ Drop-off';
    }
  },
  SpecialInstructions(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Special Instructions';
    }
  },
  EquipmentType(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Equipment Type';
    }
  },
  FirstName(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'First Name';
    }
  },
  LastName(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'Last Name';
    }
  },
  // Vendors
  Vendor(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Vendor'; }
  },
  Vendors(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Vendors'; }
  },
  VendorType(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Vendor Type'; }
  },
  FreightForwarder(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Freight Forwarder'; }
  },
  CustomsBroker(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Customs Broker'; }
  },
  PackagingCrating(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Packaging & Crating'; }
  },
  VendorAgreement(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Vendor Agreement'; }
  },
  // Vendor Groups
  VendorGroup(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Vendor Group'; }
  },
  VendorGroups(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Vendor Groups'; }
  },
  Icon(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Icon'; }
  },
  // Commodities
  Commodity(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Commodity'; }
  },
  Commodities(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Commodities'; }
  },
  // Blacklist
  Blacklist(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Blacklist'; }
  },
  BlacklistEntry(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Blacklist Entry'; }
  },
  Globally(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Globally'; }
  },
  ForCustomer(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'For a specific customer'; }
  },
  ForLocation(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'For a specific location'; }
  },
  Scope(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Scope'; }
  },
  Reason(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Reason'; }
  },
  // Rate Confirmation
  RateConfirmation(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Rate Confirmation'; }
  },
  RateConfirmations(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Rate Confirmations'; }
  },
  Signed(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Signed'; }
  },
  Rejected(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Rejected'; }
  },
  // Carrier Bills
  // PO & POD
  // Stop photos
  Photos(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Photos'; }
  },
  Remove(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Remove'; }
  },
  UploadPhotosHint(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Upload photos — gate, dock, signage'; }
  },
  // Locations
  Locations(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Locations'; }
  },
  NewLocation(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'New Location'; }
  },
  NoLocations(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'No locations found.'; }
  },
  Hours(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Hours'; }
  },
  PoPod(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'PO & POD'; }
  },
  Pod(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'POD'; }
  },
  Rating(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Rating'; }
  },
  PoPodHeading(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Delivered: PO & POD Needed'; }
  },
  PoPodSubheading(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Upload the PO number and Proof of Delivery for each load before accounting.'; }
  },
  EnterPoNumber(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Enter PO #'; }
  },
  Needed(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Needed'; }
  },
  NotRequired(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Not required'; }
  },
  NotRequiredShort(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'N/R'; }
  },
  ReadyToInvoice(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Ready to Invoice'; }
  },
  UploadPod(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Upload POD'; }
  },
  PodUploaded(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'POD uploaded'; }
  },
  RemovePod(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Remove POD'; }
  },
  NoLoadsDeliveredPoPod(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'No delivered loads awaiting PO & POD.'; }
  },
  // Load Records
  LoadRecords(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Load Records'; }
  },
  LoadCount(n: number, language?: string) {
    language = language || getLanguage();
    switch (language) { default: return `${n} load${n === 1 ? '' : 's'}`; }
  },
  TotalRevenue(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Total Revenue'; }
  },
  TotalCarrierCost(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Total Carrier Cost'; }
  },
  TotalMargin(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Total Margin'; }
  },
  PickupDate(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Pickup Date'; }
  },
  PickupFrom(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Pickup from'; }
  },
  PickupTo(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Pickup to'; }
  },
  ClearFilters(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Clear Filters'; }
  },
  Route(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Route'; }
  },
  Margin(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Margin'; }
  },
  AllStatuses(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'All statuses'; }
  },
  AllCustomers(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'All customers'; }
  },
  Open(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Open'; }
  },
  // Carrier Bills
  CarrierBill(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Carrier Bill'; }
  },
  CarrierBills(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Carrier Bills'; }
  },
  CarrierBillStatusDraft(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Draft'; }
  },
  CarrierBillStatusExported(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Exported'; }
  },
  CarrierBillStatusPaid(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Paid'; }
  },
  ReadyToExport(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Ready to Export'; }
  },
  Exported(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Exported'; }
  },
  CarrierPaid(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Carrier Paid'; }
  },
  ExportToQuickBooks(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Export to QuickBooks'; }
  },
  ExportAsOneBill(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Export as 1 Bill'; }
  },
  SyncStatus(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Sync Status'; }
  },
  MarkPaid(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Mark Paid'; }
  },
  AdditionalCharges(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Additional Charges'; }
  },
  BillNumber(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Bill #'; }
  },
  NoBillsReadyToExport(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'No invoiced loads ready to export.'; }
  },
  QuickBooks(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'QuickBooks'; }
  },
  QbConnected(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Connected'; }
  },
  QbNotConnected(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Not connected'; }
  },
  ConnectToQuickBooks(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Connect to QuickBooks'; }
  },
  DisconnectQuickBooks(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Disconnect'; }
  },
  // Vendor Packet
  VendorPackets(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Vendor Packets'; }
  },
  Submitted(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Submitted'; }
  },
  Approved(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Approved'; }
  },
  // SMS
  // Load extras
  NotBookedReason(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Reason Not Booked'; }
  },
  PaymentTerms(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Payment Terms'; }
  },
  BolNumber(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'BOL Number'; }
  },
  Specialties(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Notes / Specialties'; }
  },
  Groups(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Groups'; }
  },
  // Dashboard
  Dashboard(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Dashboard'; }
  },
  AllLoads(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'All Loads'; }
  },
  RfqsTitle(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'RFQs'; }
  },
  OpenRequests(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Open Requests'; }
  },
  LiveLoads(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Live Loads'; }
  },
  PoPodNeeded(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'PO & POD Needed'; }
  },
  TotalLoads(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Total Loads'; }
  },
  NewLoad(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'New Load'; }
  },
  NewCarrier(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'New Carrier'; }
  },
  NewCustomer(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'New Customer'; }
  },
  Accounting(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Accounting'; }
  },
  Overview(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Overview'; }
  },
  Pipeline(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Pipeline'; }
  },
  Directory(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Directory'; }
  },
  Tools(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Tools'; }
  },
  Help(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Help'; }
  },
  Send(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Send'; }
  },
  SignerName(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Signer Name'; }
  },
  SignerTitle(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Signer Title'; }
  },
  RfqEmail(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'RFQ Email'; }
  },
  RfqEmails(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'RFQ Emails'; }
  },
  Contact(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Contact'; }
  },
  Contacts(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Contacts'; }
  },
  RfqSmsNewLoads(count: number, language?: string) {
    language = language || getLanguage();
    switch (language) { default: return `${count} new`; }
  },
  RfqSmsUpdatedLoads(count: number, language?: string) {
    language = language || getLanguage();
    switch (language) { default: return `${count} updated`; }
  },
  RfqSmsBody(summary: string, url: string, language?: string) {
    language = language || getLanguage();
    switch (language) { default: return `LGX RFQ Alert: ${summary} load(s) from inbox poll. Review at ${url}`; }
  },
  Selected(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'selected'; }
  },
  SendRequests(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Send Requests'; }
  },
  SendRequestsDescription(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Select vendor groups to receive this open load request via SMS.'; }
  },
  BroadcastSms(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Broadcast SMS'; }
  },
  GroupWith(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Group with'; }
  },
  SelectCustomerFirstToGroup(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Select a customer first to group this load with another.'; }
  },
  GroupedLoads(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Grouped Loads'; }
  },
  GroupedWithAnotherLoad(parentRef?: string, language?: string) {
    language = language || getLanguage();
    switch (language) { default: return parentRef ? `Grouped with ${parentRef}` : 'Grouped with another load'; }
  },
  ChildLoadsCount(n: number, language?: string) {
    language = language || getLanguage();
    switch (language) { default: return `${n} child load${n === 1 ? '' : 's'}`; }
  },
  PartOfGroup(parentRef: string, language?: string) {
    language = language || getLanguage();
    switch (language) { default: return `Child of ${parentRef}`; }
  },
  BroadcastSmsSelectGroups(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Select the carrier groups to broadcast this load to:'; }
  },
  SendBroadcast(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Send Broadcast'; }
  },
  BroadcastSmsSent(carrierCount: number, recipientCount: number, language?: string) {
    language = language || getLanguage();
    switch (language) { default: return `Broadcast sent to ${recipientCount} contact${recipientCount === 1 ? '' : 's'} across ${carrierCount} carrier${carrierCount === 1 ? '' : 's'}.`; }
  },
  Close(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Close'; }
  },
  BroadcastSmsBody(loadRef: string, url: string, language?: string) {
    language = language || getLanguage();
    switch (language) { default: return `LGX Open Load: ${loadRef} is available. View details at ${url}`; }
  },
  RfqPhoneRecipients(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'RFQ Phone Recipients'; }
  },
  Acronym(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Acronym'; }
  },
  RfqSource(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'RFQ Source'; }
  },
  NoRfqEmailsFound(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'No RFQ emails found for this load.'; }
  },
  LoadRequest(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Load Request'; }
  },
  LoadRequests(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Load Requests'; }
  },
  OpenLoadRequest(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Open Load Request'; }
  },
  Interested(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'I\'m Interested'; }
  },
  NotInterested(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Not Interested'; }
  },
  YourQuoteOptional(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Your quote (optional)'; }
  },
  YourNotesOptional(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Notes (optional)'; }
  },
  ThanksForResponding(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Thanks for responding!'; }
  },
  AlreadyResponded(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'You already responded to this request.'; }
  },
  YouMarkedAsInterested(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'You marked this load as interested.'; }
  },
  YouMarkedAsDeclined(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'You passed on this load.'; }
  },
  InvalidRequestLink(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'This link is invalid or has expired.'; }
  },
  RespondedAt(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Responded'; }
  },
  TargetRate(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Target Rate'; }
  },
  Bids(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Bids'; }
  },
  Replies(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Replies'; }
  },
  Attachments(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Attachments'; }
  },
  BookThisLoad(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Book This Load'; }
  },
  EditLoad(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Edit Load'; }
  },
  Book(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Book'; }
  },
  Decline(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Decline'; }
  },
  NoQuote(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'No quote'; }
  },
  Booked(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Booked'; }
  },
  NoBidsYet(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'No bids or responses yet.'; }
  },
  NoRepliesYet(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'No replies yet.'; }
  },
  SelectCarrierToViewMessages(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Select a carrier to view messages'; }
  },
  AttachmentsHelpText(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'These files are attached to the booking-confirmation MMS.'; }
  },
  ConfirmBookDespiteWarnings(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'This booking has warnings. Proceed anyway?'; }
  },
  RequiresTrailerPermitType(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'This load is oversize. Enter the trailer permit type to book.'; }
  },
  BookingConfirmSmsBody(loadRef: string, pu: string, dropoff: string, rate: string, language?: string) {
    language = language || getLanguage();
    switch (language) { default: return `LGX Booking Confirmed: ${loadRef}\nPickup: ${pu}\nDelivery: ${dropoff}\nRate: ${rate}\nDispatch will follow up with paperwork.`; }
  },
  BlacklistWarning(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Blacklist'; }
  },
  MissingDocsWarning(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Missing required carrier documents'; }
  },
  TrailerPermitType(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Trailer Permit Type'; }
  },
  BookAnyway(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Book Anyway'; }
  },
  LoadDetails(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Load Details'; }
  },
  Images(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Images'; }
  },
  NoImages(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'No images attached.'; }
  },
  DriverSms(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Driver SMS'; }
  },
  CustomerSms(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Customer SMS'; }
  },
  InternalNotes(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Notes'; }
  },
  Activity(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Activity'; }
  },
  AddNote(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Add'; }
  },
  NoDriverAssigned(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'No driver assigned to this load.'; }
  },
  NoCustomerContacts(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'No customer contacts found.'; }
  },
  SelectContact(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Select a contact'; }
  },
  StatusUpdated(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Status updated.'; }
  },
  LiveLoad(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Live Load'; }
  },
  NoNotesYet(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'No notes yet.'; }
  },
  NoActivityYet(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'No status changes recorded yet.'; }
  },
  AcceptAndSign(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Accept & Sign'; }
  },
  ConfirmReject(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Reject'; }
  },
  SignYourName(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Full Name (Signature)'; }
  },
  SignerTitleLabel(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Title (optional)'; }
  },
  SignaturePreview(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Your signature will appear here'; }
  },
  RateConfirmationAccepted(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Rate Confirmation Accepted'; }
  },
  RateConfirmationRejected(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Rate Confirmation Rejected'; }
  },
  PartnerFreight(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Partner Freight'; }
  },
  AgreedRateTotal(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Agreed Rate Total'; }
  },
  InvalidRcLink(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'This rate confirmation link is invalid or has expired.'; }
  },
  Submitting(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Submitting...'; }
  },
  AcceptedBy(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Accepted by'; }
  },
  RejectedOn(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Rejected on'; }
  },
  SendRateConfirmation(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Send Rate Confirmation'; }
  },
  ResendRateConfirmation(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Resend Rate Confirmation'; }
  },
  CopySigningLink(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Copy Signing Link'; }
  },
  SigningLinkCopied(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Signing link copied!'; }
  },
  RcAwaitingResponse(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Awaiting Response'; }
  },
  RcSentSuccessfully(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Rate confirmation sent successfully.'; }
  },
  RcSentTo(sentTo: string, date: string, language?: string) {
    language = language || getLanguage();
    switch (language) { default: return `Sent to ${sentTo} on ${date}`; }
  },
  RecipientEmail(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Recipient Email'; }
  },
  RecipientName(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Recipient Name'; }
  },
  RateCarrierAndDriver(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Rate Carrier & Driver'; }
  },
  RequiredBeforeDelivered(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Required before marking load as Delivered'; }
  },
  SaveRatingsAndDeliver(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Save Ratings & Mark Delivered'; }
  },
  ArchiveLoad(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Archive Load'; }
  },
  ArchiveWarning(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'This will archive the load as not booked.'; }
  },
  NotBookedReasonRequired(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Please select a reason.'; }
  },
  ReasonPriceTooHigh(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Price too high'; }
  },
  ReasonCancelledByCustomer(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Load cancelled by customer'; }
  },
  ReasonFutureLoad(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Future load — not ready yet'; }
  },
  ReasonNoDrivers(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'No available drivers'; }
  },
  ReasonCustomerChoseAnother(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Customer went with another carrier'; }
  },
  ReasonDetailsChanged(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Load details changed'; }
  },
  EditRates(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Edit Rates'; }
  },
  BreakIntoLineItems(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Break into line items'; }
  },
  SaveRates(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Save Rates'; }
  },
  AddLineItem(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return '+ Add Line Item'; }
  },
  CarrierLineItems(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Carrier Line Items'; }
  },
  CustomerLineItems(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Customer Line Items'; }
  },
  LineItemTotal(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Total'; }
  },
  BillOfLading(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Bill of Lading'; }
  },
  ShipFrom(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Ship From'; }
  },
  ShipTo(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Ship To'; }
  },
  CommodityInformation(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Commodity Information'; }
  },
  PreviewPdf(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Preview PDF'; }
  },
  SendBol(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Send BOL'; }
  },
  BolSentSuccessfully(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'BOL sent successfully.'; }
  },
  Qty(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Qty'; }
  },
  Dimensions(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Dimensions'; }
  },
  AddRow(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return '+ Add Row'; }
  },
  Shipper(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Shipper'; }
  },
  Receiver(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Receiver'; }
  },
  Signature(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Signature'; }
  },
  Date(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Date'; }
  },
  Weight(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Weight'; }
  },
  Subject(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Subject'; }
  },
  EmailCustomer(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Email'; }
  },
  InsertTemplate(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Insert email template...'; }
  },
  EmailSent(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Email sent.'; }
  },
  SentEmails(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Sent Emails'; }
  },
  NoEmailsSent(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'No emails sent yet.'; }
  },
  SubmitForReview(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Submit for Review'; }
  },
  ApproveInvoice(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Approve'; }
  },
  RejectInvoice(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Reject'; }
  },
  RejectReason(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Rejection Reason'; }
  },
  SendInvoice(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Send Invoice'; }
  },
  InvoiceNumber(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Invoice #'; }
  },
  InvoiceDate(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Invoice Date'; }
  },
  DueDate(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Due Date'; }
  },
  BillTo(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Bill To'; }
  },
  Net30(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Net 30'; }
  },
  MoveToAccounting(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Move to Accounting'; }
  },
  InvoiceSentSuccessfully(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Invoice sent successfully.'; }
  },
  InvoiceApproved(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Invoice approved.'; }
  },
  InvoiceRejected(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Invoice rejected.'; }
  },
  AwaitingApproval(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Awaiting Approval'; }
  },
  SubmittedAt(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Submitted At'; }
  },
  ApprovedBy(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Approved By'; }
  },
  ApprovedAt(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Approved At'; }
  },
  InvoicedAt(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Invoiced At'; }
  },
  Total(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Total'; }
  },
  AmountDue(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Amount Due'; }
  },
  SendVendorPacket(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Send Vendor Packet'; }
  },
  ResendVendorPacket(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Resend Vendor Packet'; }
  },
  VendorPacketSent(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Vendor packet sent.'; }
  },
  VendorPacketReceived(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Packet Received'; }
  },
  VendorContactInformation(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Vendor Contact Information'; }
  },
  InsuranceInformation(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Insurance Information'; }
  },
  FleetEquipment(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Fleet Equipment'; }
  },
  RequiredDocuments(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Required Documents'; }
  },
  BrokerVendorAgreement(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Broker-Vendor Agreement'; }
  },
  NoMcNumber(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'No MC Number'; }
  },
  InsuranceCompany(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Insurance Company'; }
  },
  PolicyNumber(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Policy Number'; }
  },
  ExpirationDate(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Expiration Date'; }
  },
  UploadW9(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Upload W-9'; }
  },
  UploadOperatingAuthority(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Upload Operating Authority'; }
  },
  UploadInsuranceCertificate(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Upload Certificate of Insurance'; }
  },
  AgreeAndSign(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Agree & Sign'; }
  },
  SubmitPacket(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Submit Packet'; }
  },
  PacketAlreadySubmitted(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'This packet has already been submitted.'; }
  },
  InvalidPacketLink(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'This packet link is invalid or has expired.'; }
  },
  SignerTitleField(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Signer Title'; }
  },
  AwaitingSubmission(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Awaiting Submission'; }
  },
  CarrierAgreementPlaceholder(language?: string) {
    language = language || getLanguage();
    switch (language) {
      default: return 'By signing below, you agree to the LGX Freight Solutions broker-vendor agreement. You represent that the information provided is accurate and that you are authorized to bind your company to this agreement. Full terms will be provided in the executed agreement.';
    }
  },
  AddPointOfContact(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Add Point of Contact'; }
  },
  AddPoc(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Add POC'; }
  },
  AddContact(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Add Contact'; }
  },
  AddPocToWhichStop(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Add POC to which stop?'; }
  },
  ExistingContacts(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Existing Contacts'; }
  },
  NewContact(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'New Contact'; }
  },
  NoStopsOnLoad(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'No stops on this load yet.'; }
  },
  AddPhotos(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Add Photos'; }
  },
  Source(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Source'; }
  },
  TypeAMessage(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Type a message...'; }
  },
  SelectAConversation(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Select a conversation'; }
  },
  SendFailed(language?: string) {
    language = language || getLanguage();
    switch (language) { default: return 'Send failed'; }
  },
};

(strings as any).month0 = strings.January;
(strings as any).month1 = strings.February;
(strings as any).month2 = strings.March;
(strings as any).month3 = strings.April;
(strings as any).month4 = strings.May;
(strings as any).month5 = strings.June;
(strings as any).month6 = strings.July;
(strings as any).month7 = strings.August;
(strings as any).month8 = strings.September;
(strings as any).month9 = strings.October;
(strings as any).month10 = strings.November;
(strings as any).month11 = strings.December;
(strings as any).day0 = strings.Sunday;
(strings as any).day1 = strings.Monday;
(strings as any).day2 = strings.Tuesday;
(strings as any).day3 = strings.Wednesday;
(strings as any).day4 = strings.Thursday;
(strings as any).day5 = strings.Friday;
(strings as any).day6 = strings.Saturday;

export const validationStrings = {
};